import api from "api/axios";

export const createExhibitorEvent = (payload) =>
  api.post("/exhibitor-event", payload);

export const fetchExhibitorEvents = (exhibitor_id) =>
  api.post("/exhibitor-event/search/", {
    exhibitor_id,
  });

export const fetchExhibitorEventByCompany = (company_id) =>
  api.get(`/exhibitor-event/company/${company_id}`);

export const fetchExhibitorEventById = (id) =>
  api.get(`/exhibitor-event/${id}`);

export const updateExhibitorEvent = (id, payload) =>
  api.put(`/exhibitor-event/${id}`, payload);

export const deleteExhibitorEvent = (id, payload) =>
  api.delete(`/exhibitor-event/${id}`, {
    data: payload,
  });

export const fetchEventsByExhibitor = (exhibitor_id) =>
  api.get(`/exhibitor-event/exhibitor/${exhibitor_id}`);
